const colors = {
  transparent: "transparent", // 0
  black: "#292929", // 1
  white: "#ffffff", // 2
  textColor: "#292929", // 3
  lightTextColor: "#757575", // 4
  inactiveField: "#F7F7F7", // 5
  inactiveColor: "#767676", // 6
  inactiveBG: "#e6e6e6", // 7
  borderColor: "#DBDBDB", // 8
  lightBorderColor: "#ededed", //9
  primary: "#D10068", // 10
  primaryHover: "#D10068",
  lightPink: "#fff0f0",
  pink: "#ffe9e9",
  darkPink: "#f9c4d2",
  pinkBorder: "#b18597",
  pinkShadow: "#ffe3e2",
  js: "#f7df1e",
  jsx: "#61dafb",
  gql: "#E10098",
  shell: "#7E685A",
  go: '#001f3f',
  ts: "#1B4DF0",
  html: "#4F4846"
};

export default colors;
